export default class GradeFeatures {

    constructor(router, auth) {
        this.router = router
        this.auth = auth
    }

    // Navigation.

    openGrades(registrationId) {
        if (registrationId) {
            this.router.push({ name: 'dashboard-registration-grades', params: { registrationId: registrationId } })
        } else {
            this.router.push({ name: 'dashboard-grades' })
        }
    }

    // Permissions.

    hasReviewerPermission() {
        return this.auth.hasOnePermission([
            'dashboard.access-instructor-dashboard',
            'dashboard.access-internal-observer-dashboard',
            'dashboard.access-restricted-internal-observer-dashboard',
            'dashboard.access-external-observer-dashboard',
            'dashboard.access-learner-dashboard',
        ])
    }

    // Capabilities.

    canSeeGrades() {
        return this.auth.hasPermission('dashboard.access-grades-from-dashboard')
    }

    canUseAllFilters() {
        return this.auth.hasOnePermission([
            'dashboard.access-instructor-dashboard',
            'dashboard.access-internal-observer-dashboard',
            'dashboard.access-restricted-internal-observer-dashboard',
        ])
    }

    // Local vs remote data mapping.
    
    mapData(grade) {
        return {
            id: grade ? grade.id : null,
            status: grade ? grade.status : null,

            sessions_count: grade ? grade.sessions_count : null,

            position1_gonogo: grade ? grade.position1_gonogo : null,
            position1_grade: grade ? grade.position1_grade : null,

            position2_gonogo: grade ? grade.position2_gonogo : null,
            position2_grade: grade ? grade.position2_grade : null,

            final_gonogo: grade ? grade.final_gonogo : null,
            final_grade: grade ? grade.final_grade : null,

            learner: grade ? grade.learner : null,
            learner_id: grade ? grade.learner_id : null,

            registration: grade ? grade.registration : null,
            registration_id: grade ? grade.registration_id : null,

            cohort: grade ? grade.cohort : null,
            cohort_id: grade ? grade.cohort_id : null,

            degree: grade ? grade.degree : null,
            degree_id: grade ? grade.degree_id : null,

            // Accessors.
            learner_owner_name: grade ? grade.learner_owner_name : null,
            learner_entity_name: grade ? grade.learner_entity_name : null,
        }
    }

    unmapData(data) {
        let res = {...data}
        delete res.learner
        delete res.registration
        delete res.cohort
        delete res.degree
        delete res.learner_owner_name
        delete res.learner_entity_name
        return res
    }
}
